import { useState, useEffect, useRef } from 'react'
import Navbar from '../components/Navbar'
import { supabase } from '../lib/supabase'

const DISC_COLORS = {
  windsurf: '#0369a1',
  kite:     '#7c3aed',
  wing:     '#059669',
  windfoil: '#b45309',
  multi:    '#be123c',
}

const DISC_LABELS = {
  windsurf:'🏄 Windsurf', kite:'🪁 Kite', wing:'🪽 Wingfoil',
  windfoil:'⚡ Windfoil', multi:'🌊 Multi',
}

const CAT_LABELS = {
  club:'Club', school:'School', shop:'Shop', association:'Assoc.', online:'Online'
}

const SEED = [
  { id:'s1',  name:'Big Winds',                  city:'Hood River, OR',     country:'USA',          discipline:'multi',    category:'shop',   lat:45.707,  lng:-121.524 },
  { id:'s2',  name:'René Egli Fuerteventura',     city:'Sotavento',          country:'Spain',        discipline:'multi',    category:'shop',   lat:28.049,  lng:-14.331  },
  { id:'s3',  name:'HST Windsurf & WingFoil',     city:'Kanaha Beach, Maui', country:'USA',          discipline:'multi',    category:'school', lat:20.897,  lng:-156.431 },
  { id:'s4',  name:'Flisvos Sport Club Naxos',    city:'Mikri Vigla, Naxos', country:'Greece',       discipline:'multi',    category:'club',   lat:36.998,  lng:25.498   },
  { id:'s5',  name:'Kite Club Hatteras',          city:'Cape Hatteras, NC',  country:'USA',          discipline:'kite',     category:'club',   lat:35.230,  lng:-75.546  },
  { id:'s6',  name:'Dakhla Attitude',             city:'Dakhla',             country:'Morocco',      discipline:'multi',    category:'school', lat:23.714,  lng:-15.936  },
  { id:'s7',  name:'Calema Windsurfing',          city:'Merritt Island, FL', country:'USA',          discipline:'multi',    category:'shop',   lat:28.536,  lng:-80.677  },
  { id:'s8',  name:'Cape Town Kite Club',         city:'Bloubergstrand',     country:'South Africa', discipline:'kite',     category:'club',   lat:-33.804, lng:18.469   },
  { id:'s9',  name:'Cumbuco Kite Center',         city:'Cumbuco, Ceará',     country:'Brazil',       discipline:'kite',     category:'school', lat:-3.631,  lng:-38.752  },
  { id:'s10', name:'Jericoacoara Kite School',    city:'Jericoacoara',       country:'Brazil',       discipline:'multi',    category:'school', lat:-2.797,  lng:-40.512  },
  { id:'s11', name:'Kalpitiya Kite Center',       city:'Kalpitiya',          country:'Sri Lanka',    discipline:'kite',     category:'school', lat:8.229,   lng:79.732   },
  { id:'s12', name:'Boracay Kite Center',         city:'Boracay',            country:'Philippines',  discipline:'kite',     category:'club',   lat:11.967,  lng:121.926  },
  { id:'s13', name:'ION CLUB Tarifa',             city:'Tarifa',             country:'Spain',        discipline:'multi',    category:'school', lat:36.013,  lng:-5.604   },
  { id:'s14', name:'Bonaire Windsurf Place',      city:'Lac Bay',            country:'Bonaire',      discipline:'multi',    category:'club',   lat:12.103,  lng:-68.248  },
  { id:'s15', name:'West Oz Kiteboarding',        city:'Safety Bay, Perth',  country:'Australia',    discipline:'kite',     category:'school', lat:-32.462, lng:115.756  },
]

export default function GlobePage() {
  const mapRef      = useRef(null)
  const mapInstance = useRef(null)
  const markersRef  = useRef([])
  const [listings, setListings]   = useState(SEED)
  const [filter, setFilter]       = useState('all')
  const [selected, setSelected]   = useState(null)
  const [mapReady, setMapReady]   = useState(false)

  useEffect(() => {
    if (document.getElementById('leaflet-css')) { setMapReady(true); return }
    const css = document.createElement('link')
    css.id   = 'leaflet-css'
    css.rel  = 'stylesheet'
    css.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css'
    document.head.appendChild(css)
    const script = document.createElement('script')
    script.id  = 'leaflet-js'
    script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js'
    script.onload = () => setMapReady(true)
    document.head.appendChild(script)
  }, [])

  useEffect(() => {
    async function fetch() {
      const { data } = await supabase
        .from('listings')
        .select('id,name,city,country,discipline,category,description,website_url,facebook_url,address,lat,lng,is_verified,is_featured')
        .eq('status','approved')
        .not('lat','is',null)
        .not('lng','is',null)
      if (data && data.length > 0) setListings(data)
    }
    fetch()
  }, [])

  useEffect(() => {
    if (!mapReady || !mapRef.current || mapInstance.current) return
    const L = window.L
    if (!L) return
    const map = L.map(mapRef.current, {
      center: [20, 0],
      zoom: 2,
      zoomControl: true,
      scrollWheelZoom: true,
    })
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      maxZoom: 19,
    }).addTo(map)
    mapInstance.current = map
    renderMarkers()
  }, [mapReady, listings])

  useEffect(() => {
    if (!mapInstance.current) return
    renderMarkers()
  }, [filter, listings])

  function renderMarkers() {
    const L   = window.L
    const map = mapInstance.current
    if (!L || !map) return
    markersRef.current.forEach(m => map.removeLayer(m))
    markersRef.current = []
    const visible = filter === 'all' ? listings : listings.filter(l => l.discipline === filter)
    visible.filter(l => l.lat && l.lng).forEach(l => {
      const color = DISC_COLORS[l.discipline] || '#6b7280'
      const icon = L.divIcon({
        className: '',
        html: `<div style="width:14px;height:14px;border-radius:50%;background:${color};border:2.5px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.4);cursor:pointer;${l.is_featured ? 'outline:2px solid #d97706;outline-offset:1px' : ''}"></div>`,
        iconSize: [14, 14],
        iconAnchor: [7, 7],
      })
      const marker = L.marker([l.lat, l.lng], { icon })
        .addTo(map)
        .on('click', () => setSelected(l))
      marker.bindTooltip(l.name, { permanent: false, direction: 'top', offset: [0, -8] })
      markersRef.current.push(marker)
    })
  }

  const visibleCount = filter === 'all'
    ? listings.filter(l => l.lat && l.lng).length
    : listings.filter(l => l.discipline === filter && l.lat && l.lng).length

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden', position: 'relative', zIndex: 0 }}>
      <Navbar />
      <div style={{ background: '#fff', borderBottom: '1px solid var(--gray-200)', padding: '10px 18px', display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', zIndex: 10 }}>
        <div style={{ fontFamily: 'var(--mono)', fontSize: 11, fontWeight: 700, color: 'var(--gray-500)', letterSpacing: 1, textTransform: 'uppercase' }}>🗺 Map View</div>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {[['all','🌐 All'],['windsurf','🏄 Windsurf'],['kite','🪁 Kite'],['wing','🪽 Wingfoil'],['windfoil','⚡ Windfoil'],['multi','🌊 Multi']].map(([val, label]) => (
            <button key={val} onClick={() => setFilter(val)}
              style={{
                fontSize: 11, fontWeight: 600, padding: '4px 11px', borderRadius: 50,
                border: `1.5px solid ${filter === val ? (DISC_COLORS[val] || 'var(--blue)') : 'var(--gray-200)'}`,
                background: filter === val ? (DISC_COLORS[val] || 'var(--blue)') : '#fff',
                color: filter === val ? '#fff' : 'var(--gray-500)',
                cursor: 'pointer', fontFamily: 'var(--font)', transition: 'all .15s',
              }}>
              {label}
            </button>
          ))}
        </div>
        <div style={{ marginLeft: 'auto', fontSize: 12, color: 'var(--gray-400)', fontFamily: 'var(--mono)' }}>{visibleCount} locations</div>
      </div>
      <div style={{ flex: 1, position: 'relative' }}>
        <div ref={mapRef} style={{ width: '100%', height: '100%', zIndex: 0 }} />
        <div style={{ position: 'absolute', bottom: selected ? 280 : 20, left: 12, zIndex: 999, background: 'rgba(255,255,255,.95)', backdropFilter: 'blur(8px)', borderRadius: 10, padding: '10px 14px', boxShadow: '0 2px 12px rgba(0,0,0,.12)', transition: 'bottom .3s' }}>
          {Object.entries(DISC_COLORS).map(([disc, color]) => (
            <div key={disc} style={{ display: 'flex', alignItems: 'center', gap: 7, marginBottom: 4 }}>
              <div style={{ width: 10, height: 10, borderRadius: '50%', background: color, border: '2px solid #fff', boxShadow: '0 1px 3px rgba(0,0,0,.3)', flexShrink: 0 }} />
              <span style={{ fontSize: 11, color: 'var(--gray-600)', fontFamily: 'var(--font)', fontWeight: 500, textTransform: 'capitalize' }}>{disc}</span>
            </div>
          ))}
          <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginTop: 2 }}>
            <div style={{ width: 10, height: 10, borderRadius: '50%', background: 'var(--gray-300)', outline: '2px solid #d97706', outlineOffset: 1, flexShrink: 0 }} />
            <span style={{ fontSize: 11, color: 'var(--gray-600)', fontFamily: 'var(--font)', fontWeight: 500 }}>Featured</span>
          </div>
        </div>
        <div style={{ position: 'absolute', bottom: selected ? 280 : 20, right: 12, zIndex: 999, background: 'rgba(255,255,255,.9)', borderRadius: 8, padding: '6px 10px', fontSize: 11, color: 'var(--gray-400)', fontFamily: 'var(--font)', transition: 'bottom .3s' }}>
          Click a pin to view listing
        </div>
        {selected && (
          <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, zIndex: 1000, background: 'rgba(255,255,255,.98)', backdropFilter: 'blur(12px)', borderTop: '1px solid var(--gray-200)', borderRadius: '16px 16px 0 0', padding: '18px 20px 28px', boxShadow: '0 -4px 24px rgba(0,0,0,.12)', animation: 'slideUp .2s ease', maxHeight: '45vh', overflowY: 'auto' }}>
            <button onClick={() => setSelected(null)} style={{ position: 'absolute', top: 14, right: 16, width: 28, height: 28, borderRadius: '50%', background: 'var(--gray-100)', border: 'none', cursor: 'pointer', color: 'var(--gray-500)', fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>×</button>
            <div style={{ display: 'flex', gap: 6, marginBottom: 10, flexWrap: 'wrap' }}>
              {selected.discipline && <span style={{ fontSize: 10, fontFamily: 'var(--mono)', fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', padding: '3px 8px', borderRadius: 4, background: `${DISC_COLORS[selected.discipline]}22`, color: DISC_COLORS[selected.discipline], border: `1px solid ${DISC_COLORS[selected.discipline]}44` }}>{DISC_LABELS[selected.discipline]}</span>}
              {selected.category && <span style={{ fontSize: 10, fontFamily: 'var(--mono)', fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', padding: '3px 8px', borderRadius: 4, background: 'var(--gray-100)', color: 'var(--gray-500)' }}>{CAT_LABELS[selected.category] || selected.category}</span>}
              {selected.is_verified && <span style={{ fontSize: 12 }}>✅</span>}
              {selected.is_featured && <span style={{ fontSize: 10, fontFamily: 'var(--mono)', fontWeight: 700, padding: '3px 8px', borderRadius: 4, background: '#fef3c7', color: '#92400e' }}>⭐ Featured</span>}
            </div>
            <h2 style={{ fontSize: 19, fontWeight: 800, letterSpacing: '-.3px', marginBottom: 6, paddingRight: 32, color: 'var(--gray-900)', lineHeight: 1.2 }}>{selected.name}</h2>
            <div style={{ fontSize: 13, color: 'var(--gray-500)', marginBottom: selected.address ? 2 : 12 }}>📍 {selected.city}{selected.country ? `, ${selected.country}` : ''}</div>
            {selected.address && <div style={{ fontSize: 12, color: 'var(--gray-400)', marginBottom: 12, paddingLeft: 18 }}>{selected.address}</div>}
            {selected.description && <p style={{ fontSize: 13, color: 'var(--gray-600)', lineHeight: 1.6, marginBottom: 14 }}>{selected.description}</p>}
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
              {selected.website_url && <a href={selected.website_url} target="_blank" rel="noreferrer" style={{ fontSize: 13, color: 'var(--blue)', fontWeight: 500, textDecoration: 'none' }}>🌐 Website</a>}
              {selected.facebook_url && <a href={selected.facebook_url} target="_blank" rel="noreferrer" style={{ fontSize: 13, color: 'var(--blue)', fontWeight: 500, textDecoration: 'none' }}>📘 Facebook</a>}
              {selected.lat && selected.lng && <a href={`https://www.google.com/maps?q=${selected.lat},${selected.lng}`} target="_blank" rel="noreferrer" style={{ marginLeft: 'auto', fontSize: 12, color: 'var(--blue)', fontWeight: 600, textDecoration: 'none' }}>📍 Open in Google Maps</a>}
            </div>
          </div>
        )}
      </div>
      <style>{`
        @keyframes slideUp { from { transform: translateY(20px); opacity: 0 } to { transform: translateY(0); opacity: 1 } }
        .leaflet-container { font-family: var(--font) !important; }
        .leaflet-tooltip { font-family: var(--font) !important; font-size: 12px !important; font-weight: 600 !important; border-radius: 6px !important; border: 1px solid var(--gray-200) !important; box-shadow: 0 2px 8px rgba(0,0,0,.12) !important; }\
        .leaflet-pane, .leaflet-map-pane { z-index: 1 !important; }
        .leaflet-top, .leaflet-bottom { z-index: 2 !important; }
      `}</style>
    </div>
  )
}
